import { css, keyframes } from "styled-components";

export function getScrollShadowKeyframes(color: string) {
  return keyframes`
    0% {
      --top-shadow-color: ${color};
      --bottom-shadow-color: transparent;
    }
    0.01% {
      --top-shadow-color: ${color};
      --bottom-shadow-color: ${color};
    }
    99.9% {
      --top-shadow-color: ${color};
      --bottom-shadow-color: ${color};
    }
    100% {
      --top-shadow-color: transparent;
      --bottom-shadow-color: ${color};
    }
  `;
}

export function getScrollShadowMixin(
  scrollShadowKeyframes: ReturnType<typeof keyframes>
) {
  return css`
    scroll-timeline-name: --scroll-shadow;
    scroll-timeline-axis: block;

    &::before {
      content: "";
      position: absolute;
      inset: 0;
      user-select: none;
      pointer-events: none;

      box-shadow: inset 0 -7px 9px -7px var(--top-shadow-color),
        inset 0 7px 9px -7px var(--bottom-shadow-color);

      animation: ${scrollShadowKeyframes} linear;
      animation-timeline: --scroll-shadow;
    }
  `;
}
